export function OperioBrand({
  compact = false,
  centered = false,
  subtitle,
}: {
  compact?: boolean;
  centered?: boolean;
  subtitle?: string;
}) {
  const iconSize = compact ? "h-9 w-9" : "h-12 w-12";
  return (
    <div className={`flex items-center gap-3 ${centered ? "justify-center" : ""}`}>
      <img
        src="/icons/app_icon.svg"
        alt=""
        aria-hidden="true"
        className={`${iconSize} shrink-0 rounded-xl shadow-sm`}
      />
      <div className={centered ? "text-left" : ""}>
        <div className={`${compact ? "text-2xl" : "text-3xl"} font-bold tracking-tight text-blue-950`}>
          Operio
        </div>
        {subtitle && <div className="text-sm text-gray-600">{subtitle}</div>}
      </div>
    </div>
  );
}
